var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`customer-${_vm.customerIdent}`},[(!_vm.authenticated)?_c('GuestRootView'):_vm._e(),(_vm.authenticated)?_c('AuthRootView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }